import React, { lazy, Suspense } from 'react'
import { Switch, Route, useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import Auth from '../../../../Layout/Auth'
import QuotationList from '../Pages/QuotationList'
import WorkInProgress from '../../../../GlobalModules/Utility/Components/WorkInProgress'
const AddQuotation = lazy(() => import('../Pages/AddQuotation'))
const QuotationView = lazy(() => import('../Pages/QuotationView'))
const EditQuotation = lazy(() => import('../Pages/EditQuotation'))
const AddRfq = lazy(() => import('../Pages/AddRfq'))

function QuotationRoute() {
  const history = useHistory()
  return (
    <Switch>
      <Route
        exact
        path='/:lng/sales/quotations'
        render={() => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <QuotationList history={history} />
          </Auth>
        )}
      />
      <Route
        exact
        path='/:lng/sales/quotations/add'
        render={() => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <Suspense
              fallback={
                <div className='wrapper'>
                  <span>Loading</span>
                </div>
              }
            >
              <AddQuotation />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path='/:lng/sales/quotations/view/:slack'
        render={(props) => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <Suspense
              fallback={
                <div className='wrapper'>
                  <span>Loading</span>
                </div>
              }
            >
              <QuotationView {...props} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path='/:lng/sales/quotations/edit/:slack'
        render={(props) => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <Suspense
              fallback={
                <div className='wrapper'>
                  <span>Loading</span>
                </div>
              }
            >
              <EditQuotation {...props} />
            </Suspense>
          </Auth>
        )}
      />

      <Route
        exact
        path='/:lng/sales/quotations/rfq/add'
        render={() => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <Suspense
              fallback={
                <div className='wrapper'>
                  <span>Loading</span>
                </div>
              }
            >
              <AddRfq />
            </Suspense>
          </Auth>
        )}
      />

      <Route
        exact
        path='/:lng/sales/quotations/list'
        render={() => <WorkInProgress />}
      />
      <Route
        path='/:lng/sales/quotations/:unknown'
        render={() => <WorkInProgress />}
      />
    </Switch>
  )
}

const mapStateToProps = (globalState) => ({
  userCredentials: globalState.LoginReducer.userCredentials,
  userEntryType: globalState.LoginReducer.userEntryType
})

export default connect(mapStateToProps)(QuotationRoute)
